import React, { useState } from 'react';
import { Box, Skeleton } from '@mui/material';

const ImageWithSkeleton = ({ src, alt, height = 200, width = '100%', sx = {}, onErrorSrc }) => {
  const [loaded, setLoaded] = useState(false);
  const [error, setError] = useState(false);

  const handleError = (e) => {
    setError(true);
    if (onErrorSrc) {
      e.currentTarget.src = onErrorSrc;
    }
  };

  return (
    <Box sx={{ position: 'relative', height, width, ...sx }}>
      {!loaded && (
        <Skeleton
          variant="rectangular"
          width="100%"
          height="100%"
          animation="wave"
        />)
      }
      {!error && (
        <Box
          component="img"
          src={src}
          alt={alt}
          onLoad={() => setLoaded(true)}
          onError={handleError}
          sx={{
            position: 'absolute',
            inset: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            display: loaded ? 'block' : 'none',
            borderTopLeftRadius: 'inherit',
            borderTopRightRadius: 'inherit'
          }}
        />
      )}
    </Box>
  );
};

export default ImageWithSkeleton;


